module.exports = __webpack_public_path__ + "static/media/objects2_28.095d5c1e.svg";